import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import SurveyAnswerInfoLabel from './SurveyAnswerInfoLabel';

interface IProps {
  data?: any;
  text?: string;
  lng?: any;
}

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      infoWrapperStyle: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        boxSizing: 'border-box',
        alignItems: 'flex-start',
        marginBottom: '10px',
      },
      infoStyle: {
        display: 'flex',
        fontSize: '22px',
        lineHeight: '24px',
        fontWeight: FONT_WEIGHT.regular,
        color: COLORS.textBlack,
        textAlign: 'justify',
        textJustify: 'inter-word',
        // flexDirection: 'column',
        // fontWeight: FONT_WEIGHT.medium,
        fontFamily: FONTS.alegreya,
        // whiteSpace: 'nowrap',
        margin: '0 24px 10px 0',
      },
      infoTextStyle: {
        fontSize: '16px',
        color: COLORS.textBlack,
      },
      labelStyle: {
        marginRight: '4px',
      },
    })
);

const SurveyAnswerInfo = ({ data, text, lng }: IProps) => {
  const classes = useStyles();

  const getInfoItems = ({ column, data: columnData }: any, index) => {
    return (
      <div className={classes.infoStyle} key={index}>
        {column && (
          <div className={classes.labelStyle}>
            <SurveyAnswerInfoLabel label={column} lng={lng} />
          </div>
        )}
        <div className={classes.infoTextStyle}>{columnData}</div>
      </div>
    );
  };

  if (text) {
    return getInfoItems({ data: text }, 1);
  }

  const publicItems = data?.filter((item) => item.public === 'true');

  return (
    <div className={classes.infoWrapperStyle}>
      {publicItems.map(getInfoItems)}
    </div>
  );
};

export default SurveyAnswerInfo;
